import HomeFooter from 'components/Reusable/Footer/Footer';

export default HomeFooter;
